// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9k-0";
export var orangeButton = "_9k-1";